import axios from 'axios';

const RAPIDAPI_KEY = '75762b24acmsh5281a21d7a5d4f5p196915jsn78fcf7605199';
const RAPIDAPI_HOST = 'youtube-video-audio-downloader.p.rapidapi.com';

export const fetchYouTubeVideoInfo = async (url) => {
  try {
    const response = await axios.get(
      'https://youtube-video-audio-downloader.p.rapidapi.com/api/v1/youtube-media/info',
      {
        params: { url },
        headers: {
          'x-rapidapi-key': RAPIDAPI_KEY,
          'x-rapidapi-host': RAPIDAPI_HOST,
        },
      }
    );

    // Handle the API response structure
    if (response.data.status === 'success' && response.data.data) {
      const videoData = response.data.data;
      
      // Parse duration from "HH:MM:SS" format to seconds
      const parseDuration = (durationStr) => {
        if (!durationStr) return null;
        const parts = durationStr.split(':').map(Number);
        if (parts.length === 3) {
          return parts[0] * 3600 + parts[1] * 60 + parts[2];
        } else if (parts.length === 2) {
          return parts[0] * 60 + parts[1];
        }
        return parts[0];
      };

      return {
        title: videoData.title,
        uploader: videoData.uploader,
        thumbnail: videoData.thumbnail,
        duration: parseDuration(videoData.duration),
        links: videoData.links || [],
      };
    } else {
      throw new Error('Invalid response from API');
    }
  } catch (error) {
    if (error.response?.status === 429) {
      throw new Error('Too many requests. Please try again later.');
    } else if (error.response?.status === 403) {
      throw new Error('API access denied. Please check your API key.');
    } else if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error('Failed to fetch video info. Please check the URL and try again.');
    }
  }
};

export const fetchInstagramVideoInfo = async (url) => {
  try {
    const response = await axios.get(
      'https://youtube-video-audio-downloader.p.rapidapi.com/api/v1/instagram-media/info',
      {
        params: { url },
        headers: {
          'x-rapidapi-key': RAPIDAPI_KEY,
          'x-rapidapi-host': RAPIDAPI_HOST,
        },
      }
    );

    // Handle the API response structure
    if (response.data.status === 'success' && response.data.data) {
      const videoData = response.data.data;
      
      // Parse duration from "HH:MM:SS" format to seconds
      const parseDuration = (durationStr) => {
        if (!durationStr) return null;
        const parts = durationStr.split(':').map(Number);
        if (parts.length === 3) {
          return parts[0] * 3600 + parts[1] * 60 + parts[2];
        } else if (parts.length === 2) {
          return parts[0] * 60 + parts[1];
        }
        return parts[0];
      };

      return {
        title: videoData.title,
        uploader: videoData.uploader,
        thumbnail: videoData.thumbnail,
        duration: parseDuration(videoData.duration),
        links: videoData.links || [],
      };
    } else {
      throw new Error('Invalid response from API');
    }
  } catch (error) {
    if (error.response?.status === 429) {
      throw new Error('Too many requests. Please try again later.');
    } else if (error.response?.status === 403) {
      throw new Error('API access denied. Please check your API key.');
    } else if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error('Failed to fetch Instagram video info. Please check the URL and try again.');
    }
  }
};

export const validateYouTubeUrl = (url) => {
  const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|shorts\/)|youtu\.be\/)[\w-]+/;
  return youtubeRegex.test(url);
};

export const fetchFacebookVideoInfo = async (url) => {
  try {
    console.log('Fetching Facebook video info for:', url);
    
    // Build the full URL with query parameter
    const apiUrl = `https://free-facebook-downloader.p.rapidapi.com/external-api/facebook-video-downloader?url=${encodeURIComponent(url)}`;
    
    const response = await axios({
      method: 'POST',
      url: apiUrl,
      headers: {
        'x-rapidapi-key': RAPIDAPI_KEY,
        'x-rapidapi-host': 'free-facebook-downloader.p.rapidapi.com',
        'Content-Type': 'application/json',
      },
      data: {}, // Empty body as shown in the example
      timeout: 30000,
    });

    console.log('Facebook API Response:', response.data);

    // Handle the new API response structure
    if (response.data.success && response.data.links) {
      const videoData = response.data;
      
      // Convert the links object to array format
      const links = [];
      
      if (videoData.links['Download Low Quality']) {
        links.push({
          type: 'video',
          resolution: 'sd',
          download_url: videoData.links['Download Low Quality'],
        });
      }
      
      if (videoData.links['Download High Quality']) {
        links.push({
          type: 'video',
          resolution: 'hd',
          download_url: videoData.links['Download High Quality'],
        });
      }

      return {
        title: videoData.title || 'Facebook Video',
        uploader: 'Facebook',
        thumbnail: '', // This API doesn't provide thumbnail
        duration: null, // This API doesn't provide duration
        links: links,
      };
    } else if (response.data.success === false) {
      throw new Error(response.data.message || 'Failed to fetch Facebook video');
    } else {
      throw new Error('Invalid response from API');
    }
  } catch (error) {
    console.error('Facebook API Error Details:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      code: error.code,
      url: error.config?.url,
    });
    
    if (error.code === 'ECONNABORTED') {
      throw new Error('Request timeout. The server took too long to respond.');
    } else if (error.response?.status === 429) {
      throw new Error('Too many requests. Please try again later.');
    } else if (error.response?.status === 403) {
      throw new Error('API access denied. Please check your API key.');
    } else if (error.response?.status === 400) {
      throw new Error('Invalid Facebook URL. Please check the URL format.');
    } else if (error.response?.status === 404) {
      throw new Error('Video not found. The video may be private or deleted.');
    } else if (error.response?.status === 500) {
      throw new Error('Server error. The API is having issues processing this video.');
    } else if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    } else if (error.code === 'ERR_NETWORK') {
      throw new Error('Network error. Please check your internet connection or try again.');
    } else if (!error.response) {
      throw new Error('Cannot connect to the API. Please check your internet connection.');
    } else {
      throw new Error(
        'Failed to fetch Facebook video. The video may be private, region-locked, or unavailable.'
      );
    }
  }
};

export const validateInstagramUrl = (url) => {
  const instagramRegex = /^(https?:\/\/)?(www\.)?instagram\.com\/(p|reel|tv)\/[\w-]+/;
  return instagramRegex.test(url);
};

export const fetchTikTokVideoInfo = async (url) => {
  try {
    console.log('Fetching TikTok video info for:', url);
    
    const response = await axios.get(
      'https://tiktok-downloader-download-tiktok-videos-without-watermark.p.rapidapi.com/rich_response/index',
      {
        params: { url },
        headers: {
          'x-rapidapi-key': RAPIDAPI_KEY,
          'x-rapidapi-host': 'tiktok-downloader-download-tiktok-videos-without-watermark.p.rapidapi.com',
        },
        timeout: 30000,
      }
    );

    console.log('TikTok API Response:', response.data);

    // Handle the TikTok API response structure
    if (response.data && response.data.video && response.data.video.length > 0) {
      const videoData = response.data;
      
      // Build links array
      const links = [];
      
      // Add video without watermark (main video)
      if (videoData.video && videoData.video[0]) {
        links.push({
          type: 'video',
          resolution: 'hd',
          download_url: videoData.video[0],
        });
      }
      
      // Add audio/music
      if (videoData.music && videoData.music[0]) {
        links.push({
          type: 'audio',
          download_url: videoData.music[0],
        });
      }

      return {
        title: videoData.description?.[0] || 'TikTok Video',
        uploader: videoData.author?.[0] || 'TikTok User',
        thumbnail: videoData.cover?.[0] || videoData.dynamic_cover?.[0] || '',
        duration: null, // API doesn't provide duration
        links: links,
      };
    } else {
      throw new Error('Invalid response from API');
    }
  } catch (error) {
    console.error('TikTok API Error Details:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      code: error.code,
    });
    
    if (error.code === 'ECONNABORTED') {
      throw new Error('Request timeout. The server took too long to respond.');
    } else if (error.response?.status === 429) {
      throw new Error('Too many requests. Please try again later.');
    } else if (error.response?.status === 403) {
      throw new Error('API access denied. Please check your API key.');
    } else if (error.response?.status === 400) {
      throw new Error('Invalid TikTok URL. Please check the URL format.');
    } else if (error.response?.status === 404) {
      throw new Error('Video not found. The video may be private or deleted.');
    } else if (error.response?.status === 500) {
      throw new Error('Server error. The API is having issues processing this video.');
    } else if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    } else if (error.code === 'ERR_NETWORK') {
      throw new Error('Network error. Please check your internet connection or try again.');
    } else if (!error.response) {
      throw new Error('Cannot connect to the API. Please check your internet connection.');
    } else {
      throw new Error(
        'Failed to fetch TikTok video. The video may be private, region-locked, or unavailable.'
      );
    }
  }
};

export const validateFacebookUrl = (url) => {
  // More flexible regex to match various Facebook video URL formats
  const facebookRegex = /^(https?:\/\/)?(www\.|m\.|web\.)?facebook\.com\/.+/;
  
  // Check if URL contains facebook.com and has some content after it
  if (!facebookRegex.test(url)) {
    return false;
  }
  
  // Check if it's likely a video URL (contains 'video' or 'watch' or has /videos/ path)
  const hasVideoIndicator = 
    url.includes('/videos/') || 
    url.includes('/watch') || 
    url.includes('video') ||
    /\/\d+\/?$/.test(url); // ends with numbers (video ID)
  
  return hasVideoIndicator;
};

export const validateTikTokUrl = (url) => {
  const tiktokRegex = /^(https?:\/\/)?(www\.|vm\.|vt\.)?tiktok\.com\/.+/;
  return tiktokRegex.test(url);
};
